import { IconType, SvgIcon } from './SvgIcon';

export const SpeakerIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M7.33594 3.13485C7.3358 3.04199 7.30817 2.95125 7.25651 2.87409C7.20486 2.79692 7.1315 2.73678 7.04571 2.70127C6.95991 2.66575 6.86551 2.65644 6.77443 2.67452C6.68335 2.6926 6.59967 2.73725 6.53394 2.80285L4.27794 5.05818C4.19087 5.14577 4.08729 5.2152 3.9732 5.26246C3.85911 5.30973 3.73677 5.33388 3.61327 5.33351H2.0026C1.82579 5.33351 1.65622 5.40375 1.5312 5.52878C1.40618 5.6538 1.33594 5.82337 1.33594 6.00018V10.0002C1.33594 10.177 1.40618 10.3466 1.5312 10.4716C1.65622 10.5966 1.82579 10.6668 2.0026 10.6668H3.61327C3.73677 10.6665 3.85911 10.6906 3.9732 10.7379C4.08729 10.7852 4.19087 10.8546 4.27794 10.9422L6.53327 13.1982C6.599 13.264 6.68281 13.3089 6.77407 13.3271C6.86532 13.3453 6.95993 13.336 7.04589 13.3004C7.13185 13.2647 7.2053 13.2044 7.25694 13.127C7.30857 13.0496 7.33607 12.9586 7.33594 12.8655V3.13485Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6641 6C11.0968 6.57699 11.3307 7.27877 11.3307 8C11.3307 8.72123 11.0968 9.42301 10.6641 10"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9062 12.2427C13.4634 11.6855 13.9054 11.0241 14.2069 10.2961C14.5084 9.56815 14.6636 8.78793 14.6636 7.99999C14.6636 7.21205 14.5084 6.43183 14.2069 5.70387C13.9054 4.97591 13.4634 4.31448 12.9062 3.75732"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

SpeakerIcon.displayName = 'SpeakerIcon';
